// Per-component BalmUI imports (replaces full BalmUI + BalmUIPlus registration)
// Only the components actually used in the app are registered.
import UiButton from 'balm-ui/components/button';
import UiIcon from 'balm-ui/components/icon';
import UiTextfield from 'balm-ui/components/textfield';
import UiSelect from 'balm-ui/components/select';
import UiMenu from 'balm-ui/components/menu';
import UiChips from 'balm-ui/components/chips';
import UiDatepicker from 'balm-ui/components/datepicker';
import UiBadge from 'balm-ui/components/badge';
import UiSpinner from 'balm-ui/components/spinner';
import UiProgress from 'balm-ui/components/progress';
import UiDivider from 'balm-ui/components/divider';
import UiTable from 'balm-ui/components/table';
import UiTabs from 'balm-ui/components/tabs';
import UiTooltip from 'balm-ui/components/tooltip';
import UiFormField from 'balm-ui/components/form-field';
import UiForm from 'balm-ui/components/form';
import UiBottomSheet from 'balm-ui/components/bottom-sheet';

const components = [
  UiButton,
  UiIcon,
  UiTextfield,
  UiSelect,
  UiMenu,
  UiChips,
  UiDatepicker,
  UiBadge,
  UiSpinner,
  UiProgress,
  UiDivider,
  UiTable,
  UiTabs,
  UiTooltip,
  UiFormField,
  UiForm,
  UiBottomSheet,
];

export default defineNuxtPlugin({
  parallel: true,
  setup(nuxtApp) {
    components.forEach((component) => {
      nuxtApp.vueApp.use(component);
    });
  },
});
